import { http } from '../utils/axios';
import { ICoupon } from 'shared/interfaces/coupon.interface';

class CouponService {
  private static instance: CouponService;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  public static getInstance(): CouponService {
    if (!CouponService.instance) {
      CouponService.instance = new CouponService();
    }

    return CouponService.instance;
  }

  public getCouponInfo = async ({ limit = 20, page = 1 }) => {
    const data = await http<{
      result: ICoupon[];
      count: number;
    }>({
      url: '/ecommerceCoupons',
      method: 'GET',
      params: {
        limit,
        page
      }
    });
    return data;
  };

  public createCoupon = async (payload: any) => {
    const { data } = await http<ICoupon>({
      url: '/ecommerceCoupons',
      method: 'POST',
      data: payload
    });

    return data;
  };

  public getOneCoupon = async (id: string) => {
    const { data } = await http<ICoupon>({
      url: `/ecommerceCoupons/${id}`,
      method: 'GET'
    });
    return data;
  };

  public updateCoupon = async (payload: { id: string; data: ICoupon }) => {
    const { data } = await http<ICoupon>({
      url: `/ecommerceCoupons/${payload.id}`,
      method: 'PUT',
      data: payload.data
    });

    return data;
  };
}

const instance = CouponService.getInstance();

export default instance;
